import { render } from "./PermissionIndex.vue?vue&type=template&id=468e2c5e&scoped=true"
import script from "./PermissionIndex.vue?vue&type=script&lang=js"
export * from "./PermissionIndex.vue?vue&type=script&lang=js"

import "./PermissionIndex.vue?vue&type=style&index=0&id=468e2c5e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468e2c5e"]])

export default __exports__